export default __webpack_public_path__ + "static/media/googleforms.d23a25bf.webp";